import { render, staticRenderFns } from "./AccountBalance.vue?vue&type=template&id=6de6e889&scoped=true"
import script from "./AccountBalance.vue?vue&type=script&lang=js"
export * from "./AccountBalance.vue?vue&type=script&lang=js"
import style0 from "./AccountBalance.vue?vue&type=style&index=0&id=6de6e889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de6e889",
  null
  
)

export default component.exports